import { render } from "./PerformanceCards.vue?vue&type=template&id=d6f385a0"
import script from "./PerformanceCards.vue?vue&type=script&lang=js"
export * from "./PerformanceCards.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__